import List from "./pages/List";
import Wizard from "./pages/Wizard";

const routes = [
  {
    path: "*",
    element: List,
    permissions: ["EXHIBITION_MODULE"],
  },
  {
    path: ":id/*",
    element: Wizard,
    permissions: ["EXHIBITION_MODULE"],
  },
];

export default routes;
